import React from 'react';
import { Link } from 'react-router-dom';
import posts from '../blogIndex.json';

const Blog = () => {
  return (
    <section id="blog">
      <div className="container">
        <p className="section-label">blog</p>
        {posts.map((post) => (
          <div key={post.slug} className="blog-row">
            <div className="item-date">{post.date}</div>
            <div>
              <Link to={`/blog/${post.slug}`} className="blog-link">
                {post.title}
              </Link>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Blog;
